import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUserData } from '../auth/UserData';
import ServerLogger from '../utils/ClientLogger';
import { useTranslation } from 'react-i18next';

const AuthRedirect = () => {
  const { t } = useTranslation();
  const { user } = useUserData();
  const location = useLocation();
ServerLogger.log('info', user );
ServerLogger.log('info', location)

  // Redirect only if the user is authenticated and is on a blank route
  if (user && location.pathname === '/') {
    return <Navigate to="/app" />;
  }

  // Display a 404 page for any undefined route
  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>{t('notFound.title')}</h1>
      <p>{t('notFound.description')}</p>
    </div>
  );
};

export default AuthRedirect;
